import getCountryCodeByLocale from "./getCountryCodeByLocale";

const getIsDeliveryCollectionRequest = (defaultLocale: string, country: string | undefined): boolean =>
  getCountryCodeByLocale(defaultLocale) !== country;
export default getIsDeliveryCollectionRequest;
